export default "__VITE_ASSET__D2l1RxDY__"